export const TabEnum = {
  FIELD_CONFIG: 'FIELD_CONFIG',
  WORKFLOW_CONFIG: 'WORKFLOW_CONFIG',
  ANNOTATION_CONFIG: 'ANNOTATION_CONFIG',
  // 指定区域
  SPECIFIC_AREA: 'SPECIFIC_AREA',

} as const;

export const QUERY_KEYS = TabEnum;
export type Tabs = keyof typeof TabEnum;

/** 抽取字段类型 */
export const FIELD_TYPES = {
  FIELD: 'FIELD',
  TABLE: 'TABLE',
  SEAL: 'SEAL',
  HAND_WRITING: 'HANDWRITING',
} as const;

export type FieldType = keyof typeof FIELD_TYPES;
